import { Component, computed, inject, signal } from '@angular/core';
import { Router } from "@angular/router";
import { SignalsStoreService } from '../signals-store.service';
import { FooterMenu } from '../types/common.types';
import { LocalStorageService } from '../local-storage.service';
import { LOCALSTORAGE_KEYS } from '../constants/databases';
import { ModalContentTypes } from '../constants/modal-content-types';
import { ModalContentService } from '../modal-content/modal-content.service';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {

  //#region Services

  #signalsStoreService = inject(SignalsStoreService);

  #localStorageService = inject(LocalStorageService);

  #router = inject(Router);

  #modalContentService = inject(ModalContentService);

  //#endregion

  //#region Properties

  hasSession = computed(() => this.#signalsStoreService.hasSession());

  isSessionLoaded = computed(() => this.#signalsStoreService.isSessionLoaded());

  copyRightYear = new Date().getFullYear();

  menu = signal<FooterMenu[]>([
    {
      title: 'About us',
      link: 'about-us-section',
      isALink: true,
      items: [
        {
          title: 'Our promise',
          link: 'our-promise-section',
          isALink: true
        },
        {
          title: 'Our founders',
          link: 'our-founders-section',
          isALink: true
        },
        {
          title: 'Testimonials',
          link: 'testimonial-section',
          isALink: true
        }
      ]
    },
    {
      title: 'How it works',
      link: 'how-it-work-section',
      isALink: true,
      items: [
        {
          title: 'Why us?',
          link: 'why-choose-us-section',
          isALink: true
        },
        {
          title: 'How it works?',
          link: 'how-it-work-section',
          isALink: true
        },
        {
          title: 'Cost Calculator',
          link: '/cost-calculator',
          isALink: false
        }
      ]
    },
    {
      title: 'Home delivery',
      link: '',
      isALink: false,
      hideWithSession: true,
      items: [
        {
          title: 'Ran out of food?',
          link: '',
          isALink: false,
          openModal: ModalContentTypes.SET_UP_DELIVERY_HERE,
          hideWithSession: true
        }
      ]
    },
    {
      title: 'FAQ',
      link: 'faqs-section',
      isALink: true
    },
    {
      title: 'Gift Cards',
      link: '/pages/gift-cards',
      isALink: false
    }
  ]);

  logoVersionNumber = computed(() => this.#signalsStoreService.logoVersionNumber());

  //#endregion

  //#region Methods

  scrollToLink(id: string) {
    const divToScroll = document.getElementById(id);

    if (divToScroll)
      divToScroll.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  goTo(item: FooterMenu) {

    if (!item.isALink) {

      if (item.link) {
        this.#router.navigate([item.link]);
        return;
      }

      if (item.openModal)
        this.#modalContentService.openModal(item.openModal);
    }

    if (!this.#signalsStoreService.isInHomePage()) {
      this.#localStorageService.set(LOCALSTORAGE_KEYS.LINK_TO_GO_IN_HOME, item.link);
      this.#router.navigate(['/home']);
    }

    this.scrollToLink(item.link);
  }

  //#endregion
}

